import styles from './styles.module.css';
import { WorkflowsTypes } from '../../types/general';
import { CategoryBox } from '../Overview/OverviewCategories/OverviewCategories';

const Box = ({
    name,
    description,
    number,
    onClick,
    type,
}: {
    name: string;
    description: string;
    number: string;
    onClick: any;
    type: WorkflowsTypes;
}) => {
    return (
        <CategoryBox number={number} onClick={onClick(type)} isResponsive={false}>
            <div className={`${styles.folderContainer}`}>
                <span className={'h1'}>{name}</span>
                <p className={'h2'}>{description}</p>
            </div>
        </CategoryBox>
    );
};

const WorkflowCategory = ({ onClick }: { onClick: any }) => {
    return (
        <>
            <div className={styles.container}>
                <Box
                    number="01"
                    name={'Extract from documents'}
                    description={'Upload the relevant structure documents, e.g. LPA or Prospectus.'}
                    onClick={onClick}
                    type={WorkflowsTypes.Extract}
                />
                <Box
                    number="02"
                    name={'Fill in manually'}
                    description={'Enter your data directly using our guided form.'}
                    onClick={onClick}
                    type={WorkflowsTypes.Fill}
                />
                <Box
                    number="03"
                    name={'View stored'}
                    description={'Oversight of saved structures, their features, and compliance.'}
                    onClick={onClick}
                    type={WorkflowsTypes.View}
                />
            </div>
        </>
    );
};

export default WorkflowCategory;
